<template>
  <div>
    <Nav />
    <section class="section">
      <div class="container" id="Main" role="main">
        <h2 class="title is-2">Concepts of Race and Racism</h2>
        <div class="columns is-multiline">
          <div class="column is-full" v-for="concept in concepts" v-bind:key="concept.title">
            <div class="box">
              <h3 class="title card-header-title is-3">{{concept.title}}</h3>

              <div class="content">
                <p>{{concept.definition}}</p>
                <div
                  class="subconcept"
                  v-for="subconcepts in concept.subconcepts"
                  v-bind:key="subconcepts.key"
                >
                  <p class="subconcept-title">{{subconcepts.title}}</p>
                  <p>{{subconcepts.definition}}</p>
                </div>
                <hr />
                <p v-html="concept.reference"></p>
              </div>
            </div>
          </div>
        </div>
        <h2 class="title">References</h2>
        <div v-for="reference in references" v-bind:key="reference">
          <p v-html="reference"></p>
        </div>
        <router-link class="button is-primary is-medium next-button" :to="{name:'framework'}" aria-label="Review the pedagogical framework for teaching about slavery">
          <span>Review the Framework</span>
          <span class="icon is-small">
            <i class="fas fa-arrow-right"></i>
          </span>
        </router-link>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";
import { concepts, references } from "./concepts";

export default {
  name: "Concepts",
  data() {
    return {
      concepts,
      references
    };
  },
  components: {
    Nav,
    Footer
  }
};
</script>

<style scoped>
.content p {
  margin: 0 2rem !important;
}

.subconcept {
  padding-left: 2rem;
  padding-right: 1rem;
  margin-top: 1rem;
  padding-top: 1rem;
}

.subconcept-title {
  font-weight: bold;
  font-size: 1.2rem;
}

.next-button {
  margin-top: 20px;
}
</style>